<mat-tab-group (selectedTabChange)="selectedTabChange($event)" class="flex-1-1-100">
  <mat-tab label="Company Profile">
    <div class="flex flex-col">
      <table>
        <tr>
          <th>Company Name</th>
          <td *ngIf="companyInfo">{{ companyInfo?.companyName }}</td>
        </tr>
        <tr>
          <th>Company ID</th>
          <td *ngIf="companyInfo">{{ companyInfo?.companyId }}</td>
        </tr>
        <tr>
          <th>Ticket Created By</th>
          <td>
            <a href="mailto:{{dynamicData.card.createdBy.email}}" target="_top">{{dynamicData.card.createdBy.email}}</a>
          </td>
        </tr>
        <tr>
          <th>Users</th>
          <td *ngIf="companyInfo">{{ companyInfo?.numberOfPoweredUsers }} Out Of {{ companyInfo?.numberOfTotalUsers }}
            ({{ companyInfo?.numberOfPoweredUsers }} Power Users)
          </td>
        </tr>
        <tr>
          <th>License(s)</th>
          <td *ngIf="companyInfo" style="white-space: pre-line">{{ companyInfo?.products }}</td>
        </tr>

      </table>
    </div>
  </mat-tab>

  <mat-tab label="Tickets">
    <div class="flex flex-col">
      <particle-comapany-tickets [ticketId]="dynamicData.card.id" [data]="data"
                                 [board]="dynamicData.board"></particle-comapany-tickets>
    </div>
  </mat-tab>
  <mat-tab label="Notes">
    <div class="m-t-20">
      <particle-comment-box [contextPath]="contextPath"
                            [sourceType]="commentSourceType"
                            [title]="commentTitle"
                            [scope]="scope"
                            [messageType]="messageType"
                            [conversationType]="conversationType"
      ></particle-comment-box>
    </div>
  </mat-tab>
</mat-tab-group>
